var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoForwardGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5769 5.16132H11C11 5.38571 10.9086 5.60127 10.7434 5.76022C10.414 6.07655 9.88729 6.08028 9.55262 5.76913L5.49982 1.99606L1.44708 5.76908C1.11288 6.08032 0.585948 6.07659 0.256267 5.75997C-0.0892596 5.42757 -0.0847378 4.88037 0.265943 4.55379L4.90967 0.230462C5.24029 -0.076859 5.75936 -0.076859 6.09022 0.230691L10.7335 4.55361C10.9046 4.71274 11 4.93232 11 5.16132H10.5769Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoForwardGreen);
export default __webpack_public_path__ + "static/media/ico-forward-green.3ef95e1a5f1b09fe6861f3c6a0b8eb79.svg";
export { ForwardRef as ReactComponent };